// src/auth/profile/Profile.jsx
import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Form, Button, Card, Alert } from 'react-bootstrap';
import { useAuth } from '../../AuthContext';
import { useNavigate } from 'react-router-dom';

const Profile = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    nombre: '',
    usuario: '',
    correo: '',
    tipo_persona: '',
    rol: '',
    estado: ''
  });

  const [newPassword, setNewPassword] = useState('');
  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    if (!user) {
      navigate('/login');
      return;
    }

    if (!formData.nombre && user.nombre) {
      setFormData({
        nombre: user.nombre,
        usuario: user.usuario,
        correo: user.correo,
        tipo_persona: user.tipo_persona,
        rol: user.rol,
        estado: user.estado
      });
    }

    setLoading(false);
  }, [user, navigate]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSave = async () => {
    try {
      const payload = { ...formData };
      if (newPassword.trim()) payload.clave = newPassword;

      const res = await fetch(`https://apiprov.conduto.com.ec/api/usuarios/${user.id_usuario}`, {
        method: 'PUT',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.msg || 'Error al actualizar');

      setSuccess('Perfil actualizado con éxito');
      setIsEditing(false);
      setNewPassword('');
    } catch (err) {
      setError(err.message);
    }
  };

  if (loading) return <div className="text-center mt-5">Cargando...</div>;

  const isAdmin = user?.rol === 'administrador' || user?.rol === 'superusuario';

  return (
    <div className="container">
      <Row className="justify-content-center">
        <Col md={6}>
          <Card className="p-4 shadow">
            <h3 className="mb-4">Mi Perfil</h3>

            {error && <Alert variant="danger">{error}</Alert>}
            {success && <Alert variant="success">{success}</Alert>}

            <Form>
              <Form.Group className="mb-3">
                <Form.Label>Nombre</Form.Label>
                <Form.Control
                  type="text"
                  name="nombre"
                  value={formData.nombre}
                  onChange={handleChange}
                  disabled={!isEditing}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Usuario</Form.Label>
                <Form.Control
                  type="text"
                  name="usuario"
                  value={formData.usuario}
                  onChange={handleChange}
                  disabled={!isEditing}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Correo</Form.Label>
                <Form.Control
                  type="email"
                  name="correo"
                  value={formData.correo}
                  onChange={handleChange}
                  disabled={!isEditing}
                />
              </Form.Group>

              {!isAdmin && (
                <Form.Group className="mb-3">
                  <Form.Label>Tipo de Persona</Form.Label>
                  <Form.Control
                    type="text"
                    value={formData.tipo_persona === 'natural' ? 'Persona Natural' : 'Persona Jurídica'}
                    disabled
                  />
                </Form.Group>
              )}

              <Form.Group className="mb-3">
                <Form.Label>Rol</Form.Label>
                <Form.Control type="text" value={formData.rol} disabled />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Estado</Form.Label>
                <Form.Control type="text" value={formData.estado} disabled />
              </Form.Group>

              {isEditing && (
                <Form.Group className="mb-3">
                  <Form.Label>Nueva Contraseña (opcional)</Form.Label>
                  <Form.Control
                    type="password"
                    autoComplete="new-password"
                    placeholder="Deja vacío si no deseas cambiarla"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                  />
                </Form.Group>
              )}

              <div className="d-flex justify-content-end gap-2">
                {!isEditing ? (
                  isAdmin && (
                    <Button variant="primary" onClick={() => setIsEditing(true)}>
                      Editar
                    </Button>
                  )
                ) : (
                  <>
                    <Button variant="secondary" onClick={() => setIsEditing(false)}>
                      Cancelar
                    </Button>
                    <Button variant="success" onClick={handleSave}>
                      Guardar
                    </Button>
                  </>
                )}
              </div>
            </Form>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Profile;